import isArrayLike from './is-array-like';
export default function last(o) {
  if (isArrayLike(o)) {
    var arr = o;
    return arr[arr.length - 1];
  }

  return undefined;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/last.js
// module id = 48
// module chunks = 0